//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '@/mixins/global'
import axios from 'axios'

export default {
  props: {
    UserAccessData: {}
  },
  data () {
    return {
      Readiness: {
        TotalLate: 0,
        TotalAlert: 0,
        TotalNormal: 0,
        Data: []
      },
      dialog: false
    }
  },
  created () {
    // console.log('Block Fabric')
    // console.log(this.UserAccessData.FABIn)
    // console.log(this.UserAccessData.FABList)
  },
  async mounted () {
    this.getData()
    this.pullData()
  },
  methods: {
    pullData () {
      this.pulling = setInterval(() => {
        var currentdate = new Date()
        if (currentdate.getMinutes() % 5 === 0 && currentdate.getSeconds() === 0) {
          this.getData()
        }
      }, 1000)
    },
    getData () {
      var url = this.$apiFix + '2020ReadinessSum.php/wip_fc_sum_head'
      // var url = 'http://localhost/nygcontrolroom/api/2020ReadinessSum.php/wip_fc_sum_head'
      axios
        .get(url)
        .then(response => {
          this.Readiness = response.data
        })
        .catch(err => {
          console.error(err)
        })
    }
  }
}
